import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Platform } from '@ionic/angular';

@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
    constructor(private platform: Platform) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.platform.is('ios')&&!this.platform.is('mobileweb') && !this.platform.is('pwa') && !this.platform.is('desktop')) {
            return next.handle(req);
        }
        if (req.params.has('ngsw-bypass')) {
            return next.handle(req);
        }
        const cloned = req.clone({
            params: req.params.set('ngsw-bypass', 'true')
        });
        return next.handle(cloned);
    }
}